import SettingDrawer from './SettingDrawer'

export default SettingDrawer
